import React from 'react';
import { Box, Typography, Grid, Button, Container } from '@mui/material';
import { Fade, Zoom } from 'react-awesome-reveal';
import aiGif from '../assets/AI-service-image.jpg';
import softwareGif from '../assets/sdlc-service-image.jpg';
import dataGif from '../assets/data-service-image.jpg';
import consultingGif from '../assets/consulting-service-image.jpg';
import cloudGif from '../assets/cloud-service-image.jpg'; // Add the image for Cloud Operations
import talentGif from '../assets/talent-service-image.jpg'; // Add the image for Talent Management
import { Link } from 'react-router-dom';



const Services = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Fade triggerOnce={false}>
          <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mt: 5 }}>
            Our Services
          </Typography>
          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Unlock your business's full potential with our comprehensive range of cutting-edge services.
          </Typography>
        </Fade>
      </Box>

      {/* AI Solutions Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={aiGif} alt="AI Solutions" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
        <Grid item xs={12} md={6}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              AI-Driven Solutions
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Explore how our AI and machine learning solutions drive efficiency, innovation, and intelligent decision-making across industries.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              From AI-powered chatbots to predictive analytics and automation, we leverage the latest AI tools to help you make smarter business decisions.
            </Typography>
            <Typography sx={{ mt:2 }}>
              As we embrace the future, our commitment to harnessing the transformative power of AI ensures that your business remains competitive and agile in an ever-evolving landscape. Let us partner with you to unlock the full potential of AI and drive your success.
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }} component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
      </Grid>

      {/* Software Development Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Software Development
            </Typography>
            <Typography sx={{ mt: 2 }}>
              We develop bespoke software solutions designed to meet the specific requirements of your business, ensuring seamless integration and scalability.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Our expertise covers everything from web and mobile apps to complex enterprise-level systems, all tailored to your needs.
            </Typography>
            <Typography sx={{ mt: 2 }}> 
              By employing the latest technologies and development methodologies, we ensure that our software is robust, user-friendly, and adaptable to future demands. Whether you need a simple application or a comprehensive system, our dedicated team is committed to delivering high-quality software that aligns with your vision and supports your growth.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Let us help you transform your ideas into reality with custom software solutions that propel your business forward. 
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }} component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={softwareGif} alt="Custom Software Development" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
      </Grid>

      {/* Data Analytics Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={dataGif} alt="Data Analytics" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
        <Grid item xs={12} md={6}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Data Analytics & Insights
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Unlock the full potential of your data with our advanced analytics services, providing you with insights to make informed, strategic decisions.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              We specialize in transforming raw data into actionable intelligence to help your business stay ahead in a data-driven world.
            </Typography>
            <Typography sx={{ mt: 2 }}> 
              By leveraging cutting-edge tools and methodologies, we help you identify opportunities for growth, optimize operations, and enhance customer experiences. Whether you need to analyze market trends, customer behavior, or operational performance, our team is dedicated to delivering insights that drive impactful results.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Empower your decision-making with our data analytics services and turn your data into your most valuable asset. 
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }} component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
      </Grid>

      {/* Strategic Consulting Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Strategic Consulting
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Our seasoned consultants partner with you to develop strategies that align with your business goals and navigate the complexities of the modern market.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              From digital transformation to business process optimization, we offer expert guidance for sustainable growth.
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }} component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={consultingGif} alt="Strategic Consulting" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
      </Grid>

      {/* Cloud Operations Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={cloudGif} alt="Cloud Operations" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
        <Grid item xs={12} md={6}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Cloud Operations
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Maximize efficiency and scalability with our comprehensive cloud solutions. Whether you're migrating to the cloud or optimizing existing infrastructures, we provide end-to-end cloud management services.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              From cloud migration to cost optimization and security management, our team ensures your business stays agile, secure, and future-proof.
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }}  component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
      </Grid>

      {/* Talent Management Section */}
      <Grid container spacing={4} alignItems="center" sx={{ mb: 5 }}>
        <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
          <Fade direction="up" triggerOnce={false}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
              Talent Management
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Empower your business with a strong workforce. Our talent management services provide customized recruitment, onboarding, and employee development strategies to foster growth.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              We help you attract, retain, and develop top talent while aligning human resource strategies with your business objectives.
            </Typography>
            <Button variant="contained" sx={{ mt: 3 }} component={Link} to="/contact">
              Get In Touch
            </Button>
          </Fade>
        </Grid>
        <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
          <Zoom triggerOnce={false}>
            <Box component="img" src={talentGif} alt="Talent Management" sx={{ width: '100%', borderRadius: '8px' }} />
          </Zoom>
        </Grid>
      </Grid>

    </Container>
  );
};

export default Services;